import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import SlideCalendar from './SlideCalendar';

const useStyles = makeStyles((theme) => ({
  container: {
    height: '200px',
    width: '100%',
    minWidth: '100%',
    padding: '30px 115px',
    position: 'absolute',
    zIndex: 2
  },
  subContainer: {
    maxWidth: '1024px',
    minWidth: 840,
    width: '75%',
    margin: '0 auto'
  },

  agenda: {
    marginTop: '15px',
    marginRight: 'auto',
    marginLeft: 'auto',
    maxWidth: '1110px'
  }
}));

const SubHeader = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.container}>
      <div className={classes.subContainer}>
        <div className={classes.agenda}>
          <SlideCalendar />
        </div>
      </div>
    </Paper>
  );
};

export default SubHeader;
